import * as React from 'react';
import * as PropTypes from 'prop-types';

var Page = function Page(props) {
  var handlePage = function handlePage(e) {
    e.stopPropagation();
    props.onChangePage(props.page);
  };

  return /*#__PURE__*/React.createElement("li", {
    onClick: handlePage,
    className: props.active ? 'active' : undefined
  }, /*#__PURE__*/React.createElement("a", null, props.page));
};

Page.propTypes = {
  page: PropTypes.number,
  active: PropTypes.bool,
  onChangePage: PropTypes.func
};
Page.defaultProps = {
  page: 1,
  active: false,
  onChangePage: null
};
export default Page;